<div class="contact-block-wrap">
  <app-info-item icon="localization" label="TIBAU DO SUL | RN" link="https://bit.ly/37WsIf4" [opacity]="0.5"></app-info-item>
  <app-info-item icon="phone" label="(84) 93300.5548" link="https://api.whatsapp.com/send?phone=5584933005548&text=Ol%C3%A1%2C%20bem-vindo(a)%20%C3%A0%20Para%C3%ADso%20Fotovoltaico!%20Fale%20comigo%20por%20aqui..." [opacity]="0.5"></app-info-item>
  <app-info-item icon="instagram" label="SIGA-NOS" link="https://www.instagram.com/paraisofotovoltaico/"></app-info-item>
</div>
